export async function mailIdentity(runtime, options) {
  if (runtime.readIdentity) return runtime.readIdentity(options);
  const attributes = await runtime.fetchUserAttributes();
  const token = await runtime.getIdToken();
  if (!attributes?.sub || !token) throw new Error('Please sign in again to open Mail Center.');
  return { attributes, token };
}

export async function mailDashboardRequest(runtime, owner, url) {
  const identity = await mailIdentity(runtime);
  if (identity.attributes.sub !== owner) throw new Error('Your account changed. Refresh Mail Center before continuing.');
  const response = await runtime.fetch(url, { headers: { Authorization: `Bearer ${identity.token}` }, signal: AbortSignal.timeout(20000) });
  if (!response.ok) throw new Error('Unable to load mail. Please retry.');
  const data = await response.json();
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Unable to read mail. Please retry.');
  if ((await mailIdentity(runtime)).attributes.sub !== owner) throw new Error('Your account changed. Refresh Mail Center before continuing.');
  return data;
}

export const metric = value => typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
export function normalizeMailItems(data, type) {
  if (!Array.isArray(data.items) || (data.nextToken != null && typeof data.nextToken !== 'string')) throw new Error('Unable to read the newsletter list. Please retry.');
  return data.items.map(n => {
    const id = n?.newsletterId || n?.id || n?.pk;
    if (typeof id !== 'string' || !id || (n.subject != null && typeof n.subject !== 'string')) throw new Error('Unable to read the newsletter list. Please retry.');
    return { id, subject: n.subject || '(no subject)', sentAt: n.sentAt || n.date || '', updatedAt: n.updatedAt || n.date || '',
      displayDate: (type === 'drafts' ? n.updatedAt : n.sentAt) || n.date || '', type,
      deliveryStatus: typeof n.deliveryStatus === 'string' ? n.deliveryStatus : null,
      recipients: metric(n.recipients ?? n.totalRecipients ?? n.stats?.recipients),
      uniqueOpens: metric(n.uniqueOpens ?? n.stats?.uniqueOpens), uniqueClicks: metric(n.uniqueClicks ?? n.stats?.uniqueClicks),
      openRate: metric(n.openRate), clickRate: metric(n.clickRate) };
  });
}
